export default __webpack_public_path__ + "static/media/non.62249be7.svg";